import React from 'react';
import styled from 'styled-components';
import { styles } from 'yankees-react-utils';
import Objective from './Objective';

const CategoryTitle = styled.div`
    font-size: 1rem;
    color: ${styles.theme.fontColors.doveGray};
    font-weight: bold;
`;
const ObjectiveWrapper = styled.div`
    margin: 0.375rem 0 1rem;
`;

const ObjectiveCategory = ({ category, objectives }) => (
    <div>
        <CategoryTitle>
            {category.name}
        </CategoryTitle>
        {objectives.map((objective) => (
            <ObjectiveWrapper key={objective.ObjectiveID}>
                <Objective objective={objective} />
            </ObjectiveWrapper>
        ))}
    </div>
);

export default ObjectiveCategory;
